import { FileDropZoneTranslate } from './fileDropZone.model';

const fileDropZoneTranslatePTBR: FileDropZoneTranslate = {
  placeholder: 'Arraste um arquivo aqui ou clique para selecionar',
  changeFile: 'Trocar arquivo',
  dragRejected: 'Tipo não permitido',
  dropToReplace: 'Solte para substituir o arquivo',
  cancelLabel: 'Cancelar envio',
  removeLabel: 'Remover arquivo',
  errors: {
    invalidType: 'Tipo de arquivo não permitido',
    tooLarge: 'Arquivo muito grande (máximo {{size}} MB)',
  },
};

export default fileDropZoneTranslatePTBR;
